import Vue from 'vue'
import Router from 'vue-router'
import Guan from '@/page/Guan'
import Service from '@/page/Service'
import Case from '@/page/Case'
import We from '@/page/We'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Guan',
      component: Guan,
      // redirect: '/Guan',
    },
    {
      path: '/Service',
      name: 'Service',
      component: Service
    },
    {
       path: '/Case',
       name: 'Case',
       component: Case
     },
    {
      path: '/We',
      name: 'We',
      component: We
    },
//         ]
// },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js